import {Pipe, PipeTransform} from '@angular/core';
import {HouseNo} from "../../data/models/houseno/houseno";

@Pipe({
    name: 'houseNoPipe',
  standalone: true
})
export class HouseNoPipe implements PipeTransform {
  transform(houseno: string): string {
    if (!houseno) {
      return houseno;
    }
    try {
      return HouseNo.formatForHuman(houseno);
    } catch (e) {
      console.error("HouseNo konnte nicht formatiert werden:", houseno, e);
      return houseno;
    }
  }
}
